define(function () {

    'use strict';

    return {
        export : "export"
    };
});
